import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IFormHelperProps, TextField } from 'telia-front-react';
import { helperInErrorState, PHONE_FIELD_ID } from '../../util/FieldHelperUtil';

interface PhoneFieldProps {
  value: string;
  onChange: (value: string) => void;
  getHelper: () => IFormHelperProps | undefined;
  shouldValidate: boolean;
  isDisabled?: boolean;
}

const PhoneField = observer((props: PhoneFieldProps): React.JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const { value, onChange, getHelper, shouldValidate, isDisabled } = props;
  const [phoneHelper, setPhoneHelper] = React.useState<IFormHelperProps | undefined>(undefined);

  React.useEffect(() => {
    setPhoneHelper(getHelper());
  }, [value, shouldValidate]);

  return (
    <TextField
      id={PHONE_FIELD_ID}
      type="text"
      isInvalid={helperInErrorState(phoneHelper)}
      label={translate('form.fields.phone')}
      value={value}
      onChange={onChange}
      input={{ autoComplete: 'off' }}
      isDisabled={isDisabled}
      errorMessage={helperInErrorState(phoneHelper) ? (phoneHelper.text as string) : undefined}
    />
  );
});

export default PhoneField;
